/**
 * EmulatorsSection - Sub-component for BuildApkPage
 *
 * Renders the two emulator cards (Android emulator + Flutter emulator).
 */
import React from 'react';
import { Smartphone, Package } from 'lucide-react';

export const EmulatorsSection: React.FC = () => {
  return (
    <div className="mb-8">
      <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">🎮 Emuladores</h2>
      <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
        {/* Card 1: Emulador Android */}
        <div className="bg-white rounded-xl shadow-xl border-2 border-green-200">
          <div className="bg-gradient-to-r from-green-600 to-green-500 p-4">
            <div className="flex items-center gap-2">
              <Smartphone className="w-6 h-6 text-white" />
              <h3 className="text-xl font-bold text-white">Emulador Android</h3>
            </div>
            <p className="text-green-100 mt-1 text-sm">
              Teste direto no navegador
            </p>
          </div>
          <div className="p-6">
            <p className="text-gray-600 mb-4 text-sm">
              Emulador Android rodando no navegador com suporte a touch e gestos.
            </p>
            <button
              onClick={() => window.open('http://localhost:6080', '_blank')}
              className="w-full py-3 rounded-lg font-semibold text-white bg-green-600 hover:bg-green-700 transition-all"
            >
              <div className="flex items-center justify-center gap-2">
                <Smartphone className="w-4 h-4" />
                <span>Abrir Emulador Android</span>
              </div>
            </button>
            <p className="text-xs text-gray-500 mt-2 text-center">
              Porta: 6080 | Tipo: noVNC Android
            </p>
          </div>
        </div>

        {/* Card 2: Flutter Emulador (Android + Web) */}
        <div className="bg-white rounded-xl shadow-xl border-2 border-blue-200">
          <div className="bg-gradient-to-r from-blue-600 to-cyan-500 p-4">
            <div className="flex items-center gap-2">
              <Smartphone className="w-6 h-6 text-white" />
              <h3 className="text-xl font-bold text-white">Flutter Emulador</h3>
            </div>
            <p className="text-blue-100 mt-1 text-sm">
              Android e Web em tempo real
            </p>
          </div>
          <div className="p-6 space-y-3">
            <p className="text-gray-600 mb-3 text-sm">
              Teste o app Flutter no Android ou Web diretamente.
            </p>

            <button
              onClick={() => window.open('http://localhost:5900', '_blank')}
              className="w-full py-3 rounded-lg font-semibold text-white bg-blue-600 hover:bg-blue-700 transition-all"
            >
              <div className="flex items-center justify-center gap-2">
                <Smartphone className="w-4 h-4" />
                <span>Flutter Android (Emulador)</span>
              </div>
            </button>
            <p className="text-xs text-gray-500 text-center">Porta: 5900 | Emulador noVNC</p>

            <div className="relative py-2">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300"></div>
              </div>
              <div className="relative flex justify-center text-xs">
                <span className="bg-white px-2 text-gray-500">OU</span>
              </div>
            </div>

            <button
              onClick={() => window.open('http://localhost:8080', '_blank')}
              className="w-full py-3 rounded-lg font-semibold text-cyan-600 bg-cyan-50 hover:bg-cyan-100 transition-all border-2 border-cyan-200"
            >
              <div className="flex items-center justify-center gap-2">
                <Package className="w-4 h-4" />
                <span>Flutter Web (Navegador)</span>
              </div>
            </button>
            <p className="text-xs text-gray-500 text-center">Porta: 8080 | Web Build</p>
          </div>
        </div>
      </div>
    </div>
  );
};
